import { lazy } from "react"; 
import { MOD_HAIR_ASSESSMENT } from "@/configs/ModulesConfig";
const HairAssessmentForm = lazy(() => import("./HairAssessmentForm")); 
const HairAssessmentFormDetails = lazy(() => import("./HairAssessmentFormDetails")); 
const HairAssessmentPage = lazy(() => import("./HairAssessmentPage")); 

const route = [
  {
    path: MOD_HAIR_ASSESSMENT.base_path,
    element: <HairAssessmentPage />,
    auth: MOD_HAIR_ASSESSMENT.auth,
  },
  {
    path: MOD_HAIR_ASSESSMENT.routes.form,
    element: <HairAssessmentForm />,
    auth: MOD_HAIR_ASSESSMENT.auth,
  },
  {
    path: MOD_HAIR_ASSESSMENT.routes.detail,
    element: <HairAssessmentFormDetails />,
    auth: MOD_HAIR_ASSESSMENT.auth,
  },
];

export default route;
